import {MerchantRow} from '@/src/components/Table/MerchantTable/types';

export interface MerchantApiResponse {
  id: number;
  name: string;
  logo: string | null;
  subscribers: number;
  total_offers: number;
  distributed_to_you: number;
}

export interface MerchantsApiResponse {
  data: MerchantApiResponse[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    has_more?: boolean;
  };
}

export const transformMerchantForTable = (
  merchant: MerchantApiResponse
): MerchantRow => {
  return {
    id: merchant.id,
    name: merchant.name,
    photo: merchant.logo || '',
    subscribers: merchant.subscribers.toString(),
    totalOffers: merchant.total_offers.toString(),
    distributedToYou: merchant.distributed_to_you.toString(),
    isToggled: false
  };
};

export const getMerchantsResponseTransformer = (
  response: MerchantsApiResponse
) => {
  return {
    data: response.data.map(transformMerchantForTable),
    pagination: response.pagination
  };
};
